var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic" }, [
    _vm._v(_vm._s(_vm.VUE_APP_NAME)),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }